import { BrowserRouter, Navigate, Route, Routes } from "react-router"

import { ErrorBoundary } from "@/components/error-boundary"
import { AppShell } from "@/components/chat/app-shell"
import { Home, Workspace } from "@/components/chat/workspace"
import { Spinner } from "@/components/ui/spinner"
import { ChatProvider, useChat } from "@/chat/store"
import { Join } from "@/screens/join"
import { RoomInfo } from "@/screens/room-info"
import { Thread } from "@/screens/thread"

/**
 * Everything past the sign-in gate needs a live socket, and the socket is not
 * opened until there is a session token to introduce. Gating here rather than
 * per-screen keeps every route below it able to assume a connection is being
 * attempted.
 */
function Gate() {
  const { authStatus } = useChat()

  if (authStatus === "checking") {
    return (
      <AppShell className="items-center justify-center">
        <Spinner />
      </AppShell>
    )
  }

  if (authStatus === "signedOut") return <Join />

  return (
    <Routes>
      <Route element={<Workspace />}>
        <Route path="/" element={<Home />} />
        <Route path="/r/:id" element={<Thread />} />
        <Route path="/r/:id/info" element={<RoomInfo />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export function App() {
  return (
    <ErrorBoundary>
      <ChatProvider>
        <BrowserRouter>
          <Gate />
        </BrowserRouter>
      </ChatProvider>
    </ErrorBoundary>
  )
}

export default App
